import React from "react";
import { Navigate } from "react-router-dom";
import { useBusinessUnit } from "../../context/BusinessUnitContext";

const PortalIndexRedirect = () => {
  const { isLoaded, landingPath } = useBusinessUnit();

  if (!isLoaded) return null;
  return <Navigate to={landingPath} replace />;
};

export default PortalIndexRedirect;
